import clsx from 'clsx'

import UserImage from 'components/UserImage'

import { IUserInfoProps } from './types'
import useUserInfo from './useUserInfo'

const UserInfo = ({
  avatar,
  fullName,
  createdAt,
  className
}: IUserInfoProps) => {
  const { commentTime } = useUserInfo({ createdAt })
  return (
    <div className={clsx('flex items-center gap-2', className)}>
      <UserImage src={avatar} className="h-[34px] w-[34px]" />
      <div className="flex flex-col">
        <span className="text-sm font-semibold">{fullName}</span>
        <span className="text-xs">{commentTime}</span>
      </div>
    </div>
  )
}
export default UserInfo
